const APP_ENV_FIELD = "REACT_APP_ENV";
const IS_API_FIELD = "REACT_APP_IS_API_HOST";

export const ENVS = {
  DEVELOPMENT: "dev",
  QA: "qa",
  PRODUCTION: "production",
};

export const environmentName = process.env[APP_ENV_FIELD];
export const isHost = process.env[IS_API_FIELD];
